export default __webpack_public_path__ + "static/box-b22a598ac31ff4dbc1be77ecd5bd7208.png";